import { ChatAssistantBubble } from "./ChatAssistantBubble";

type ChatWelcomeBubbleProps = {
  message: string;
  compact?: boolean;
};

export function ChatWelcomeBubble({ message, compact = false }: ChatWelcomeBubbleProps) {
  return <ChatAssistantBubble content={message} compact={compact} sanitize={false} />;
}
